import { ParametrosWSBase, DestinoConexion } from "../ParametrosWSBase";
import { EncabezadoRespuestaInterna } from "../EncabezadoRespuestaInterna";

export function ConsultaControlRemotoRest_Parametros(datos: any) {
  var par: ParametrosWSBase = {
    nombreProceso: "ConsultaControlRemotoRest",
    rutaEndPoint: "/EnterpriseServices/Sel/ConsultaControlRemotoRest",
    sistemaOrigen: "SEL",
    AGREGAR_ENCABEZADO: true,
    DESTINO_SERVICIO: DestinoConexion.Proxy,
    parametros: { ...datos },
        cRC:null
  };

  return par;
}


//entrada
export interface ConsultaControlRemotoRest_entrada {
    HDFlag:     string;
    Pais:       string;
    TipoCuenta: string;
}

export function builtConsultaControlRemotoRestEntrada(l_HDFlag: string, l_Pais: string,l_TipoCuenta: string){
    var retorno: ConsultaControlRemotoRest_entrada={
        HDFlag:     l_HDFlag,
        Pais:       l_Pais,
        TipoCuenta: l_TipoCuenta
    }

    return retorno; 
}

//salida
export interface ConsultaControlRemotoRest_salida {
    resultado:          string;
    resultadodesc:      string;
    ListaControlRemoto: ListaControlRemoto;
}

export interface ListaControlRemoto {
    ControlRemoto: ControlRemoto[];
}

export interface ControlRemoto {
    Producto:    string;
    Descripcion: string;
    Imagen:      string;
    Manual:      string;
    Precio:      string;
    TIPO_CUENTA: string;
    TIPO_EQUIPO: string;
}


export type ConsultaControlRemotoRest_Respuesta = EncabezadoRespuestaInterna & ConsultaControlRemotoRest_salida;